import Validator from 'jsonschema'

import {
  REQUEST_FORM,
  RECEIVE_FORM,
  UPDATE_DATA,
  REQUEST_SEND_TO_CUSTOMER,
  RECEIVE_SEND_TO_CUSTOMER,
  REQUEST_SURVEY_IN_PROGRESS,
  RECEIVE_SURVEY_IN_PROGRESS,
  REQUEST_SURVEY_SUBMITTED,
  RECEIVE_SURVEY_SUBMITTED,
  REQUEST_SURVEY_REVIEWED,
  RECEIVE_SURVEY_REVIEWED,
  REQUEST_CHANGE_CUSTOMER_EMAIL,
  RECEIVE_CHANGE_CUSTOMER_EMAIL,
  FETCH_USERGUIDE,
  RECEIVE_USERGUIDE,
  FETCH_CSV,
  RECEIVE_CSV,
  FETCH_ITEMS,
  RECEIVE_ITEMS,
} from '../actions'

function form(state = {
  isFetching: false,
  pages: [],
  formErrors: {},
  fetchData: {},
  hasErrors: false,
  isFetchingGuide: false,
  formUserGuideUrl: "",
}, action) {
  switch (action.type) {
    case REQUEST_FORM:
      return Object.assign({}, state, {
        isFetching: true
      })
    case RECEIVE_FORM:
      var errorList = validateFormPages(action.data.pages);
      //console.log(errorList);
      return Object.assign({}, state, {
        formErrors: errorList,
        hasErrors: hasErrors(errorList)
      }, action.data);

    case FETCH_ITEMS:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_ITEMS:
      var newFormData = makeFormDataFromJson(state.pages, action.fetchData);
      var errorList = validateFormPages(newFormData);
      return Object.assign({}, state, {
        isFetching: false,
        formErrors: errorList,
        hasErrors: hasErrors(errorList)
      });

    case FETCH_USERGUIDE:
    return Object.assign({}, state, {
      isFetchingGuide: true,
      formUserGuideUrl: "",
    });

    case RECEIVE_USERGUIDE:
      return Object.assign({}, state, {
        isFetchingGuide: false,
        formUserGuideUrl: action.data.userguide_url,
      });

      case FETCH_CSV:
      return Object.assign({}, state, {
        isFetchingCSV: true,
        formCSVUrl: "",
      });
  
      case RECEIVE_CSV:
        return Object.assign({}, state, {
          isFetchingCSV: false,
          formCSVUrl: action.data.saved_survey_url,
        });
  
    case REQUEST_SEND_TO_CUSTOMER:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_SEND_TO_CUSTOMER:
      return Object.assign({}, state, {
        isFetching: false,
      }, action.data);
    case REQUEST_SURVEY_IN_PROGRESS:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_SURVEY_IN_PROGRESS:
      return Object.assign({}, state, {
        isFetching: false,
      }, action.data);
    case REQUEST_SURVEY_SUBMITTED:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_SURVEY_SUBMITTED:
      return Object.assign({}, state, {
        isFetching: false,
      }, action.data);
    case REQUEST_SURVEY_REVIEWED:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_SURVEY_REVIEWED:
      return Object.assign({}, state, {
        isFetching: false,
      }, action.data);
    case REQUEST_CHANGE_CUSTOMER_EMAIL:
      return Object.assign({}, state, {
        isFetching: true
      });
    case RECEIVE_CHANGE_CUSTOMER_EMAIL:
      return Object.assign({}, state, {
        isFetching: false,
      }, action.data);

    case UPDATE_DATA:
      var pageData = Object.assign({}, state.pages[action.page - 1], { formData: action.data });
      var updatedPages = state.pages.map((o, i) => {
        if (i === action.page - 1) {
          return pageData;
        } else {
          return o;
        }
      });

      var errorList = validateFormPages(updatedPages);

      return Object.assign({}, state, {
        isFetching: false,
        formErrors: errorList,
        hasErrors: hasErrors(errorList),
        pages: updatedPages
      })
    default:
      return state
  }
}

function parseValue (valueType, targetData) {
  // console.log ("value:", value);
  let returnObject = {};
  let value, unit = undefined;
  if (targetData.hasOwnProperty('value')) {
    value = targetData.value;
  }
  if (targetData.hasOwnProperty('unit')) {
    unit = targetData.unit;
  }

  if (valueType.type === "object") {
    returnObject = {
      value: {
        value,
        unit,
      }
    }
  } else {
    if (valueType.type === "number" || valueType.type === "string" || valueType.type === "boolean") {
      returnObject = {
          value,
          unit,
      } 
    } 
  }
  return returnObject;
}

function recurseJson (location, targetData) {
  let returnObj = {};
  let child = {};
  Object.keys (location).forEach (element => {
  // check if folder
    if (!location[element].properties.hasOwnProperty('value')) {
      child = recurseJson (location[element].properties, targetData);
      returnObj [element]=child;
    } else {
      // parse possible value, unit, comment
      // check if survey keys match
      Object.keys (targetData).forEach (targetKey => {
        if (targetKey === element) {
            const valueObject = parseValue(location[element].properties.value, targetData[targetKey]);
            if (targetData[targetKey].hasOwnProperty('comment')) {
              valueObject["comment"] = targetData[targetKey].comment;
            }
            returnObj[element] = valueObject;
        }
      });
    }
  });
  return returnObj;
}

function makeFormDataFromJson(pages,  json) {
  pages.forEach(element => {
    let formDataForPage = recurseJson(element.schema.properties, json);
    element.formData = formDataForPage;
  });
  return pages;
}

function hasErrors(errorList) {
  return !errorList.every(function (error) {
    return error.length == 0;
  });
}

function validateFormPages(pages) {
  return pages.map((page, i) => {
    return Validator.validate(pages[i].formData, pages[i].schema).errors
  });
}

export default form


// WEBPACK FOOTER //
// ./src/reducers/form.js